export default __webpack_public_path__ + "static/N0251-e21049b3c1eda90a76dd41fe8993fcbf.png";